import React, { useContext, useLayoutEffect, useState } from 'react';
import ReusableScaffold from '../reusable/ReusableScaffold/ReusableScaffold.js';
import { messageManager } from '../System/messageManager/messageManager.js';
import { useNameConventions } from '../../contexts/nameConventionsContext.js';
import { AI_ANALYTICS_SLOTS, getAiAnalyticsTabButtons, getCardTitle, SELECT_OPTIONS, TIME_PERIOD_LABEL } from './aiAnalyticsHelpers.js';
import { BODY_SLOT } from '../PBBStrategist/pbbStrategistHelpers.js';
import { ForgeCard, ForgeOption, ForgeSelect, ForgeToolbar } from '@tylertech/forge-react';
import ToolbarTitle from '../reusable/Toolbars/ToolbarHelperComponents/ToolbarTitle.js';
import UserFriendlyFieldWrapper from '../reusable/UserFriendlyFieldWrapper.js';
import PbbStrategistOverviewTab from './AiAnalyticsComponents/PbbStrategistOverviewTab.js';
import ChatHistoryTab from './AiAnalyticsComponents/ChatHistoryTab.js';
import { LoaderContext } from '../../contexts/loaderContext.js';

const AiAnalytics = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [timePeriod, setTimePeriod] = useState(SELECT_OPTIONS[0]);
  const { nameConventions } = useNameConventions();
  const { setLoading, loading } = useContext(LoaderContext);

  const handleTabChange = (tab) => setActiveTab(tab);
  const handleChange = (e) => setTimePeriod(e?.detail);

  useLayoutEffect(() => {
    setLoading(true);
  }, [activeTab, timePeriod]);

  return (
    <ReusableScaffold
      headerTabButtons={getAiAnalyticsTabButtons()}
      handleTabChange={handleTabChange}
      activeTab={activeTab}
      title={messageManager(nameConventions).AI_ANALYTICS.TITLE}
    >
      <div slot={BODY_SLOT} className="standardMarginWithTabs scrollContainer">
        <ForgeCard no-padding className="fullHeight scrollContainer" >
          {loading ? <div /> :
          <div className="fullHeight flexContainer direction-column scrollContainer">
            <ForgeToolbar>
              <ToolbarTitle title={getCardTitle(activeTab)} />
              <UserFriendlyFieldWrapper>
                <ForgeSelect
                  invalid={!SELECT_OPTIONS.find(opt => opt.value === timePeriod.value)}
                  slot={AI_ANALYTICS_SLOTS.END}
                  value={timePeriod}
                  onchange={handleChange}
                  syncPopupWidth={true}
                  label={TIME_PERIOD_LABEL}
                >
                  {SELECT_OPTIONS.map((option) => (
                    <ForgeOption key={option.value} value={option}>
                      {option.label}
                    </ForgeOption>
                  ))}
                </ForgeSelect>
              </UserFriendlyFieldWrapper>
            </ForgeToolbar>
            <div className="tabContainer scrollContainer">
              {activeTab === 0 ? <PbbStrategistOverviewTab timePeriod={timePeriod} /> : <ChatHistoryTab timePeriod={timePeriod} />}
            </div>
          </div>
          }
        </ForgeCard>
      </div >
    </ReusableScaffold >
  );
};

export default AiAnalytics;
